// Theme: vaporwave-sunset
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'vaporwave-sunset',
  name: 'VAPORWAVE SUNSET',
  tagline: 'VAPORWAVE SUNSET',
  description: 'Recolor epico de Vaporwave com rosa quente de por do sol.',
  category: 'retro-memory',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#241032', '#3A1A4A', '#F472B6', '#FDE8F8'],
  familyId: 'vaporwave',
  variantName: 'SUNSET',
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-vaporwave-sunset'
  },
  colorVars: {
    '--accent': '#F472B6',
    '--accent-foreground': '#241032',
    '--background': '#241032',
    '--border': '#8A3A7A',
    '--card': '#3A1A4A',
    '--card-border-active': 'rgba(244, 114, 182, 0.55)',
    '--card-completed': '#311640',
    '--card-foreground': '#FDE8F8',
    '--card-glow': 'rgba(244, 114, 182, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#FDE8F8',
    '--hold-fill': '#F472B6',
    '--input': '#8A3A7A',
    '--modal-bg': '#241032',
    '--modal-border': '#8A3A7A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#8A3A7A',
    '--muted-foreground': '#FDE8F8',
    '--nav-active': '#F472B6',
    '--nav-bg': '#3A1A4A',
    '--popover': '#3A1A4A',
    '--popover-foreground': '#FDE8F8',
    '--primary': '#F472B6',
    '--primary-foreground': '#241032',
    '--ring': '#F472B6',
    '--secondary': '#8A3A7A',
    '--secondary-foreground': '#FDE8F8',
    '--streak': '#F472B6',
    '--success': '#22c55e',
    '--success-foreground': '#241032',
    '--xp': '#F472B6',
    '--xp-bg': '#3A1A4A'
  },
  resolvedVars: {
    '--accent': '#F472B6',
    '--accent-foreground': '#241032',
    '--accent-foreground-hsl': '275 52% 13%',
    '--accent-foreground-oklch': 'from #241032 l c h',
    '--accent-hsl': '329 86% 70%',
    '--accent-oklch': 'from #F472B6 l c h',
    '--background': '#241032',
    '--background-hsl': '275 52% 13%',
    '--background-oklch': 'from #241032 l c h',
    '--border': '#8A3A7A',
    '--border-hsl': '312 41% 38%',
    '--border-oklch': 'from #8A3A7A l c h',
    '--border-w': '1px',
    '--card': '#3A1A4A',
    '--card-border-active': 'rgba(244, 114, 182, 0.55)',
    '--card-completed': '#311640',
    '--card-completed-hsl': '279 49% 17%',
    '--card-completed-oklch': 'from #311640 l c h',
    '--card-foreground': '#FDE8F8',
    '--card-foreground-hsl': '314 84% 95%',
    '--card-foreground-oklch': 'from #FDE8F8 l c h',
    '--card-glow': 'rgba(244, 114, 182, 0.10)',
    '--card-hsl': '280 48% 20%',
    '--card-oklch': 'from #3A1A4A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FDE8F8',
    '--foreground-hsl': '314 84% 95%',
    '--foreground-oklch': 'from #FDE8F8 l c h',
    '--hold-fill': '#F472B6',
    '--hold-fill-hsl': '329 86% 70%',
    '--hold-fill-oklch': 'from #F472B6 l c h',
    '--input': '#8A3A7A',
    '--input-hsl': '312 41% 38%',
    '--input-oklch': 'from #8A3A7A l c h',
    '--modal-bg': '#241032',
    '--modal-bg-hsl': '275 52% 13%',
    '--modal-bg-oklch': 'from #241032 l c h',
    '--modal-border': '#8A3A7A',
    '--modal-border-hsl': '312 41% 38%',
    '--modal-border-oklch': 'from #8A3A7A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#8A3A7A',
    '--muted-foreground': '#FDE8F8',
    '--muted-foreground-hsl': '314 84% 95%',
    '--muted-foreground-oklch': 'from #FDE8F8 l c h',
    '--muted-hsl': '312 41% 38%',
    '--muted-oklch': 'from #8A3A7A l c h',
    '--nav-active': '#F472B6',
    '--nav-active-hsl': '329 86% 70%',
    '--nav-active-oklch': 'from #F472B6 l c h',
    '--nav-bg': '#3A1A4A',
    '--nav-bg-hsl': '280 48% 20%',
    '--nav-bg-oklch': 'from #3A1A4A l c h',
    '--popover': '#3A1A4A',
    '--popover-foreground': '#FDE8F8',
    '--popover-foreground-hsl': '314 84% 95%',
    '--popover-foreground-oklch': 'from #FDE8F8 l c h',
    '--popover-hsl': '280 48% 20%',
    '--popover-oklch': 'from #3A1A4A l c h',
    '--primary': '#F472B6',
    '--primary-foreground': '#241032',
    '--primary-foreground-hsl': '275 52% 13%',
    '--primary-foreground-oklch': 'from #241032 l c h',
    '--primary-hsl': '329 86% 70%',
    '--primary-oklch': 'from #F472B6 l c h',
    '--radius': '12px',
    '--ring': '#F472B6',
    '--ring-hsl': '329 86% 70%',
    '--ring-oklch': 'from #F472B6 l c h',
    '--secondary': '#8A3A7A',
    '--secondary-foreground': '#FDE8F8',
    '--secondary-foreground-hsl': '314 84% 95%',
    '--secondary-foreground-oklch': 'from #FDE8F8 l c h',
    '--secondary-hsl': '312 41% 38%',
    '--secondary-oklch': 'from #8A3A7A l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#F472B6',
    '--streak-hsl': '329 86% 70%',
    '--streak-oklch': 'from #F472B6 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#241032',
    '--success-foreground-hsl': '275 52% 13%',
    '--success-foreground-oklch': 'from #241032 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(329 86% 70% / 0.15)',
    '--xp': '#F472B6',
    '--xp-bg': '#3A1A4A',
    '--xp-bg-hsl': '280 48% 20%',
    '--xp-bg-oklch': 'from #3A1A4A l c h',
    '--xp-hsl': '329 86% 70%',
    '--xp-oklch': 'from #F472B6 l c h'
  }
}
